import axios from "axios";
import {
  Timestamp,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  setDoc,
  where
} from "firebase/firestore";
import { collectionData, docData } from "rxfire/firestore";
import { tap } from "rxjs/operators";
import { store } from "../";
import { notification$, totaltransaction$ } from "../redux/action";
import { db } from "./firebase";

import {NumericFormat} from "react-number-format";

const current_timestamp = Timestamp.fromDate(new Date());

export const CurrencyFormat = ({ amount, prefix, seperator }) => {
  return (
    <NumericFormat
      thousandSeparator={seperator}
      displayType={"text"}
      prefix={prefix}
      value={amount}
      decimalScale={2}
      fixedDecimalScale
    />
  );
};

export const CryptoCurrencyFormat = ({ amount, suffix }) => {
  return (
    <NumericFormat
      thousandSeparator={false}
      displayType={"text"}
     // suffix={suffix}
      value={amount}
      decimalScale={3}
      fixedDecimalScale
    />
  );
};

export const addUsers = async (docid, userdatas) => {
  const querydoc = doc(db, `users/${docid}`);
  await setDoc(querydoc, userdatas, { merge: true });
};

export const creditWallet = async (userid, wallet, data) => {
  const querydoc = doc(db, "users", `${userid}`, "wallet", wallet);
  await setDoc(querydoc, data, { merge: true });
};

export const getUserInfo = (userid) => {
  const querydoc = doc(db, `users/${userid}`);
  return docData(querydoc);
};

export const getTransactions = (userid) => {
  const transactionref = query(
    collection(db, "users", `${userid}`, "transactions"),
    where("main", "==", true)
  );
  return collectionData(transactionref, { idField: "uid" })
    .pipe(
      tap((transactions) => console.log("This is all transaction observable!"))
    )
    .subscribe((trans) => {
      console.log(trans.length);
      store.dispatch(totaltransaction$(trans.length));
    });
};

export const getTransactionsType = async (userid, coinType) => {
  const transactionref = query(
    collection(db, "users", `${userid}`, "transactions"),
    where("cointitle", "==", coinType),
    orderBy("timestamp", "desc")
  );
  const querySnapshot = await getDocs(transactionref);
  return querySnapshot;
};

export const addTransfer = async (userid, data) => {
  const docRef = doc(collection(db, "users", userid, "transactions"));

  return await setDoc(docRef, { ...data, timestamp: current_timestamp });
};

export const updateUserBalance = (userid, cointype, balance) => {
  const querydoc = doc(db, `users/${userid}`);
  console.log(balance);
  return setDoc(querydoc, { [cointype]: Number(balance) }, { merge: true });
};

export const getallusers = () => {
  const collectionRef = collection(db, "users");
  const q = query(collectionRef, orderBy("timestamp", "desc"));
  return collectionData(q, { idField: "uid" });
};

export const getuserDataAdmin = (id) => {
  const davidDocRef = doc(db, `users/${id}`);
  return docData(davidDocRef, { idField: "uid" });
};

export const getuserDataBalanceAdmin = (id, type) => {
  const DocRef = doc(db, "users", `${id}`, "account", type);
  return docData(DocRef, { idField: "uid" });
};

export const updateuserDataBalanceAdmin = (id, type, balance) => {
  const DocRef = doc(db, "users", `${id}`, "account", type);
  setDoc(DocRef, { balance: parseInt(balance) }, { merge: true });
  alert("User info has been updated successfully");
};

export const activateAccount = async (uid, current) => {
  const DocRef = doc(db, "users", `${uid}`);
  await setDoc(
    DocRef,
    { activated: current, Verificationstatus: current },
    { merge: true }
  );
};

export const getallWalletTransaction = () => {
  const collectionRef = collection(db, "transactionswallet");
  const q = query(collectionRef, orderBy("timestamp", "desc"));
  return collectionData(q, { idField: "uid" });
};

export const getallUserTrans = (id) => {
  const collectionRef = collection(db, "users", id, "transactions");
  const q = query(collectionRef, orderBy("timestamp", "desc"));
  return collectionData(q, { idField: "uid" });
};

export const addNotification = async (id, title, message) => {
  const DocRef = doc(collection(db, "users", `${id}`, "notification"));
  await setDoc(DocRef, { title: title, message: message });
};

export const getNotification = (id) => {
  const notificationRef = query(
    collection(db, "users", `${id}`, "notification")
  );
  return collectionData(notificationRef, { idField: "uid" }).subscribe(
    (data) => {
      store.dispatch(notification$(data));
    }
  );
};

export const deletedocument = async (id) => {
  await deleteDoc(doc(db, "users", id));
};

export const sendMessage = (message, subject, email, name) => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify({
    message: message,
    to: `anthonyerics84@gmail.com, ${email}`,
    subject: subject,
    name: name,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  return fetch(
    "https://expresspage.vercel.app/kryptospace",
    requestOptions
  ).then((response) => response.text());
};

export const COINGECKO_PRICE_URL =
  "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin%2Cethereum%2Cbinancecoin%2Ctron%2Ctether%2C&vs_currencies=usd&include_24hr_change=true";

const COINGECKO_CACHE_KEY = "coingecko_prices_v1";
const COINGECKO_TTL_MS = 75 * 1000; // ~75s — avoid free-tier rate limits

let memoryPriceCache = null; // { data, fetchedAt }
let inFlightPriceRequest = null;

const readStoredPrices = () => {
  try {
    const raw = localStorage.getItem(COINGECKO_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.data || !parsed?.fetchedAt) return null;
    return parsed;
  } catch {
    return null;
  }
};

const writeStoredPrices = (entry) => {
  memoryPriceCache = entry;
  try {
    localStorage.setItem(COINGECKO_CACHE_KEY, JSON.stringify(entry));
  } catch {
    // ignore quota / private mode
  }
};

const getFreshCache = () => {
  const entry = memoryPriceCache || readStoredPrices();
  if (!entry) return null;
  if (!memoryPriceCache) memoryPriceCache = entry;
  if (Date.now() - entry.fetchedAt < COINGECKO_TTL_MS) return entry.data;
  return null;
};

const getAnyCache = () => {
  const entry = memoryPriceCache || readStoredPrices();
  if (!entry) return null;
  if (!memoryPriceCache) memoryPriceCache = entry;
  return entry.data;
};

/**
 * Cached CoinGecko prices. Hits the network at most once per TTL window.
 * On 429/network failure, returns stale cache when available.
 */
export const fetchCoinPrices = async () => {
  const fresh = getFreshCache();
  if (fresh) return fresh;

  if (inFlightPriceRequest) return inFlightPriceRequest;

  inFlightPriceRequest = axios
    .get(COINGECKO_PRICE_URL)
    .then((res) => {
      const data = res.data;
      writeStoredPrices({ data, fetchedAt: Date.now() });
      return data;
    })
    .catch((error) => {
      const stale = getAnyCache();
      if (stale) {
        console.warn(
          "CoinGecko fetch failed; using cached prices.",
          error?.response?.status || error?.message
        );
        return stale;
      }
      throw error;
    })
    .finally(() => {
      inFlightPriceRequest = null;
    });

  return inFlightPriceRequest;
};

/** Normalize display codes (e.g. "USDT TRC20") to symbols. */
export const getCryptoSymbol = (code) => {
  if (!code) return "USDT";
  const upper = String(code).toUpperCase();
  if (upper.includes("USDT")) return "USDT";
  if (upper.includes("BTC") || upper.includes("BITCOIN")) return "BTC";
  if (upper.includes("ETH") || upper.includes("ETHER")) return "ETH";
  if (upper.includes("BNB")) return "BNB";
  if (upper.includes("TRX") || upper.includes("TRON")) return "TRX";
  return upper.split(" ")[0];
};

export const usdToCryptoByPrice = (usdAmount, price) => {
  const usd = Number(usdAmount);
  const rate = Number(price);
  if (!Number.isFinite(usd) || !Number.isFinite(rate) || rate === 0) return 0;
  return usd / rate;
};

export const cryptoToUsdByPrice = (cryptoAmount, price) => {
  const amount = Number(cryptoAmount);
  const rate = Number(price);
  if (!Number.isFinite(amount) || !Number.isFinite(rate) || rate === 0) return 0;
  return amount * rate;
};

export const cryptoToCryptoByPrice = (amount, fromPrice, toPrice) => {
  const value = Number(amount);
  const fromRate = Number(fromPrice);
  const toRate = Number(toPrice);
  if (
    !Number.isFinite(value) ||
    !Number.isFinite(fromRate) ||
    !Number.isFinite(toRate) ||
    toRate === 0
  ) {
    return 0;
  }
  return (value * fromRate) / toRate;
};

export const getCoinFromWallet = (walletData, code) => {
  const symbol = getCryptoSymbol(code);
  return walletData?.find(
    (c) => c.code === code || c.codeswap === symbol || c.code === symbol
  );
};

export const getNetworkCoinPrice = (walletData, network) => {
  const symbol = network === "TRC20" ? "TRX" : "ETH";
  return (
    walletData?.find((c) => c.codeswap === symbol || c.code === symbol)?.price ||
    0
  );
};

export const Price = function ({ amount, price }) {
  const value = cryptoToUsdByPrice(amount, price);

  return (
    <>
      You will receive{" "}
      <CurrencyFormat amount={value} prefix="$" seperator={true} /> USD
    </>
  );
};

export const getWhatsapp = async () => {
  const querydoc = doc(db, `whatsapp/number`);
  const data = await getDoc(querydoc);
  return data.data();
};
